var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsStarFilled = function SvgIconsStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.703 4.444-3.634 7.363-8.125 1.18 5.88 5.731-1.389 8.092 7.268-3.82 7.267 3.82-1.388-8.092 5.879-5.731-8.125-1.18z",
    fill: "#B7B7B7",
    fillRule: "evenodd"
  })));
};
export { SvgIconsStarFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0xNi43MDMgNC40NDQtMy42MzQgNy4zNjMtOC4xMjUgMS4xOCA1Ljg4IDUuNzMxLTEuMzg5IDguMDkyIDcuMjY4LTMuODIgNy4yNjcgMy44Mi0xLjM4OC04LjA5MiA1Ljg3OS01LjczMS04LjEyNS0xLjE4eiIgZmlsbD0iI0I3QjdCNyIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";